import {http} from '@/utils';
import type {PayMethod} from '@/common-pages/recharge/recharge.service';

export type RechargeGiftScene =
  | 'LOGIN_HOME'
  | 'RECHARGE_ENTRY'
  | 'BANNER'
  | 'ACTIVITY_CENTER';

export type RechargeGiftHiddenReason =
  | 'PARAM_INVALID'
  | 'ACTIVITY_CLOSED'
  | 'TIER_EMPTY'
  | 'COMPLETED'
  | 'NO_ENABLED_TIER';

export interface RechargeGiftTier {
  show: boolean;
  reason?: RechargeGiftHiddenReason | null;
  configId?: number | null;
  activityName?: string | null;
  currencyCode?: string | null;
  currentTierNo?: number | null;
  rechargeAmount?: number | null;
  giftAmount?: number | null;
  totalArrivalAmount?: number | null;
  giftWaterMultiple?: number | null;
  completedTierCount?: number | null;
  totalTierCount?: number | null;
  progressStatus?: number | null;
  /** 普通充值入口是否启用礼包拦截，不影响活动页和 Banner 专用入口。 */
  rechargeInterceptStatus?: 0 | 1 | null;
  interceptCooldownHours?: number | null;
  dailyPopupLimit?: number | null;
}

export interface CreateRechargeGiftOrderRequest {
  payTypeId: number;
  tierNo: number;
  entryScene: RechargeGiftScene;
  payTag?: string;
  payCategory?: number;
  useType?: number;
}

export interface RechargeGiftPaymentResult {
  payStr?: string;
  orderNo?: string;
  thirdOrderNo?: string;
}

export const getCurrentRechargeGift = (scene: RechargeGiftScene) =>
  http.post<{scene: RechargeGiftScene}, RechargeGiftTier>(
    'app/v1/activity/rechargeGift/current',
    {scene},
  );

export const createRechargeGiftOrder = (data: CreateRechargeGiftOrderRequest) =>
  http.post<CreateRechargeGiftOrderRequest, string | RechargeGiftPaymentResult>(
    'app/v1/activity/rechargeGift/order/create',
    data,
  );

export type RechargeGiftPayMethod = Pick<
  PayMethod,
  | 'id'
  | 'payName'
  | 'payTag'
  | 'payIcon'
  | 'activeDescription'
  | 'minAmount'
  | 'maxAmount'
>;
